import { render, staticRenderFns } from "./Kiosk-Promotions.vue?vue&type=template&id=9b029b74&scoped=true"
import script from "./Kiosk-Promotions.vue?vue&type=script&lang=js"
export * from "./Kiosk-Promotions.vue?vue&type=script&lang=js"
import style0 from "./Kiosk-Promotions.vue?vue&type=style&index=0&id=9b029b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b029b74",
  null
  
)

export default component.exports